const keys = {
  homeStructureCondition: {
    placeholder: {
      plumbingType: 'ex. Copper',
      roofReplacementYear: 'ex. 2015',
      roofType: 'ex. Asphalt Shingles',
      structureDamages: 'ex. Never',
    },
    titles: {
      plumbingType: "How would you describe your home's plumbing type?",
      roofReplacementYear: 'When was the last time your roof was 100% redone or rebuilt? (Year)',
      roofType: "How would you describe your home's roof type?",
      structureDamages:
        'Has there been any cracks/damage in the foundation or water infiltration through the roof, foundation and windows in the last 10 years?',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
